import { render, staticRenderFns } from "./SettingPwdComponent.vue?vue&type=template&id=13bdf475&scoped=true"
import script from "./SettingPwdComponent.vue?vue&type=script&lang=js"
export * from "./SettingPwdComponent.vue?vue&type=script&lang=js"
import style0 from "./SettingPwdComponent.vue?vue&type=style&index=0&id=13bdf475&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bdf475",
  null
  
)

export default component.exports